<template>
  <div class="survey-icon-container" :style="circleColorStyle">
    <div class="first-size circle">
      <div class="second-size circle">
        <div class="third-size circle">
          <div class="inner-circle pulse">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function hexToRgb(hex) {
  const clean = hex.replace(/^#/, '')
  if (clean.length === 3) {
    const r = parseInt(clean[0] + clean[0], 16)
    const g = parseInt(clean[1] + clean[1], 16)
    const b = parseInt(clean[2] + clean[2], 16)
    return { r, g, b }
  }
  if (clean.length === 6) {
    const r = parseInt(clean.slice(0, 2), 16)
    const g = parseInt(clean.slice(2, 4), 16)
    const b = parseInt(clean.slice(4, 6), 16)
    return { r, g, b }
  }
  return { r: 0, g: 109, b: 54 }
}

export default {
  name: 'SurveyInfoCircle',
  props: {
    color: {
      type: String,
      default: '#006d36'
    }
  },
  computed: {
    circleColorStyle() {
      const { r, g, b } = hexToRgb(this.color)
      return {
        '--circle-r': r,
        '--circle-g': g,
        '--circle-b': b
      }
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes ring-pulse {
  0%,
  100% {
    opacity: 0.25;
  }
  25% {
    opacity: 0.55;
  }
  50% {
    opacity: 0.85;
  }
  75% {
    opacity: 0.55;
  }
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0.35);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0);
  }
}

.pulse {
  animation: pulse-animation 2s infinite;
}

.survey-icon-container {
  width: 232px;
  height: 232px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  .circle {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
      border: 1px solid;
      pointer-events: none;
      transform: translateZ(0);
      backface-visibility: hidden;
      will-change: opacity;
      animation: ring-pulse 2s infinite;
    }
  }

  .first-size {
    width: 192px;
    height: 192px;

    &::before {
      width: 192px;
      height: 192px;
      border-color: rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0.1);
      animation-delay: 0.6s;
    }
  }

  .second-size {
    width: 152px;
    height: 152px;

    &::before {
      width: 152px;
      height: 152px;
      border-color: rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0.15);
      animation-delay: 0.3s;
    }
  }

  .third-size {
    width: 112px;
    height: 112px;

    &::before {
      width: 112px;
      height: 112px;
      border-color: rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0.2);
      animation-delay: 0s;
    }
  }

  .inner-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: rgba(var(--circle-r), var(--circle-g), var(--circle-b), 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
